import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useAuth } from './AuthContext';
import {
  readOrderPreferences,
  saveOrderPreferences,
} from '../utils/orderWorkspacePreferences';

const OrderWorkspaceContext = createContext(null);

const OrderWorkspaceSession = ({ username, children }) => {
  const [preferences] = useState(() => readOrderPreferences(username));
  const [recentQuery, rememberQuery] = useState(preferences.query);
  const [expandedColumns, setExpandedColumns] = useState(
    preferences.expandedColumns,
  );
  const [receipt, setReceipt] = useState(null);
  useEffect(() => {
    saveOrderPreferences(username, recentQuery, expandedColumns);
  }, [username, recentQuery, expandedColumns]);
  const recordReceipt = useCallback((next) => setReceipt(next), []);
  return (
    <OrderWorkspaceContext.Provider
      value={{
        recentQuery,
        rememberQuery,
        expandedColumns,
        setExpandedColumns,
        receipt,
        recordReceipt,
      }}
    >
      {children}
    </OrderWorkspaceContext.Provider>
  );
};

export const OrderWorkspaceProvider = ({ children }) => {
  const { user } = useAuth();
  return (
    <OrderWorkspaceSession
      key={user?.username || 'anonymous'}
      username={user?.username}
    >
      {children}
    </OrderWorkspaceSession>
  );
};
export const useOrderWorkspace = () => useContext(OrderWorkspaceContext);
